import chatStore from '../../store/ChatStore';
import { WEvent } from './WEvent';

export class WChatEvent extends WEvent {
  id: string;

  pid: string;
  nick: string;
  myBot: boolean;

  country: string;

  text: string;
  emoji: boolean;

  constructor(event: WChatEvent) {
    super(event.tableId, event.eventType, event.eventTime);
    Object.assign(this, event);
  }

  applyWebsocketChanges = (): Promise<void> => {
    const message = { ...this };
    chatStore.addChatMessage(message);
    return Promise.resolve();
  };
}
